import { BlameLogType } from '@debbie/common/dist/blamelog/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ButtonDrop from '../../ButtonDrop.js';
import { Table } from '../../index.js';
import { Meta } from './style.js';
export const TribunalDetails = ({ blamelog }) => {
    const [open, setOpen] = useState(false);
    return (React.createElement(ButtonDrop, { open: open, onOpen: () => setOpen(true), onClose: () => setOpen(false), size: "mini", info: true, maxWidth: "500px", minWidth: "500px" },
        React.createElement(Meta, null,
            React.createElement(Table, { zebra: true },
                React.createElement(TribunalDetailsContent, { blamelog: blamelog })))));
};
const TribunalDetailsContent = ({ blamelog }) => {
    switch (blamelog.type) {
        case BlameLogType.TribunalCaseCreate:
            return React.createElement(TribunalCaseCreateContent, { blamelog: blamelog });
        case BlameLogType.TribunalJobCreate:
            return React.createElement(TribunalJobCreateContent, { blamelog: blamelog });
        case BlameLogType.TribunalJobPatch:
            return React.createElement(TribunalJobPatchContent, { blamelog: blamelog });
        default:
            return null;
    }
};
const TribunalCaseCreateContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.tribunalType)),
            React.createElement("td", null, lang.tribunalCaseTypes?.[details.type] ||
                details.type))));
};
const TribunalJobCreateContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.jobType)),
            React.createElement("td", null, lang.tribunalJobTypes?.[details.jobType] || details.jobType))));
};
const TribunalJobPatchContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.jobType)),
            React.createElement("td", null, lang.tribunalJobTypes?.[details.jobType] || details.jobType)),
        details.dateUpdated && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.dateUpdated)),
            React.createElement("td", null, details.dateUpdated))),
        details.fileUploaded && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.fileUploaded)),
            React.createElement("td", null, lang.misc.yes))),
        details.costsRegistered != null && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.costsRegistered)),
            React.createElement("td", null, details.costsRegistered))),
        details.meetingStateChanged && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.meetingStateChanged)),
            React.createElement("td", null, lang.courtMeetingState?.[details.meetingStateChanged] || details.meetingStateChanged))),
        details.noteUpdated && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.noteUpdated)),
            React.createElement("td", null, lang.misc.yes)))));
};
//# sourceMappingURL=TribunalDetails.js.map